/* This component is an icon-only button and it's currently used only on some of the pages (Investigations, Users, Api Keys).
for other cases, please refer to GenericButton.tsx file which can also be used as an Icon only button or a button that accepts an icon
probably this will be subject for refactoring, but it's not clear atm which are all the buttons and shapes that we're going to use*/

import type { ComponentType, FC, Ref } from 'react';

import { Loader2 } from 'lucide-react';

import { Button, type ButtonProps } from '@shared/components/ui';

import { GenericTooltip } from './GenericTooltip';
import { IconIndicator, type IconIndicatorProps } from './IconIndicator';

interface IconButtonProps extends Omit<ButtonProps, 'children' | 'variant'> {
  icon: ComponentType<{ className?: string }>;
  tooltip?: string;
  indicator?: IconIndicatorProps;
  isLoading?: boolean;
  label?: string;
  variant?: 'default' | 'primary';
  ref?: Ref<HTMLButtonElement>;
}

export const IconButton: FC<IconButtonProps> = ({
  icon: Icon,
  tooltip,
  indicator,
  isLoading,
  className,
  variant = 'default',
  label,
  ref,
  ...props
}) => {
  const baseClasses =
    'w-9 h-9 rounded-full transition-colors flex items-center justify-center cursor-pointer relative bg-transparent focus-ring-rounded';

  const variantClasses = {
    default: 'text-foreground hover:bg-accent',
    primary: 'text-primary border-2 border-primary hover:bg-accent-primary',
  };

  const buttonContent = (
    <Button ref={ref} className={`${baseClasses} ${variantClasses[variant]} ${className}`} {...props}>
      {isLoading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : (
        <>
          <Icon className="h-6! w-6! shrink-0" />
          {indicator && <IconIndicator {...indicator} />}
        </>
      )}
    </Button>
  );

  if (tooltip) {
    return <GenericTooltip content={tooltip}>{buttonContent}</GenericTooltip>;
  }

  return buttonContent;
};
